import React, { useContext, useRef } from 'react';
import { flex } from 'src/styling/constants';
import type { CSSInterpolation } from '@emotion/serialize';
import type { HeaderButtonProps } from 'src/components/layout/redesign/header-mobile/header-button';
import HeaderButton from 'src/components/layout/redesign/header-mobile/header-button';
import { SiteContext } from 'src/context/site-context';
import { mqDesktopHeader } from 'src/components/layout/redesign/header-shared/header-styling';
import RedesignLinkDropdownCta from 'src/components/common/redesign-link-dropdown-cta';

export type HeaderActionsProps = {
  primaryButton?: HeaderButtonProps;
  secondaryButton?: HeaderButtonProps;
  onHover: () => void;
  linkDropdownCta?: Queries.LinkDropdownCta;
};

const createComponentStyling = (isGlobalPage: boolean) =>
  ({
    actions: [
      flex.rowCentered,
      {
        gap: '0.75rem',
        flexDirection: 'row',
        flexWrap: 'wrap',
        flexGrow: 1,
        justifyContent: 'flex-end',
      },
      isGlobalPage &&
        mqDesktopHeader({
          paddingTop: ['0.5rem', '0'],
          flexDirection: ['column', 'row'],
          justifyContent: ['flex-start', 'flex-end'],
        }),
    ],
    button: {
      textWrap: 'nowrap',
    },
  }) satisfies Record<string, CSSInterpolation>;

const HeaderActions = ({
  primaryButton,
  secondaryButton,
  onHover,
  linkDropdownCta,
}: HeaderActionsProps) => {
  const { isGlobalPage } = useContext(SiteContext);
  const componentStyling = createComponentStyling(isGlobalPage);
  const headerButtonRef = useRef<HTMLAnchorElement | null>(null);
  const redesignLinkDropdownCtaRef = useRef<HTMLDivElement | null>(null);

  return (
    <div css={componentStyling.actions} onPointerOver={onHover}>
      {secondaryButton && (
        <HeaderButton {...secondaryButton} styles={componentStyling.button} ref={headerButtonRef} />
      )}
      {primaryButton && !linkDropdownCta?.enabled && (
        <HeaderButton {...primaryButton} styles={componentStyling.button} />
      )}
      {linkDropdownCta?.enabled && (
        <RedesignLinkDropdownCta
          links={linkDropdownCta.dropdownOptions}
          ref={redesignLinkDropdownCtaRef}
          {...linkDropdownCta}
        />
      )}
    </div>
  );
};

export { HeaderActions };
